
/**
 * Definition of the types of messages that can be exchanged between the various components
 * @date 03/04/2024 - 13:06:28
 *
 * @type {Object}
 */
export const ICOMMANDType = {
    ClientLists : 1,
    ClientListsResponse : 2,
    SetActor: 5,
    SetBackground: 6,
    RestartMH: 7
}